/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {ParentBox, relayWrap} from '../../box-utils/ParentBox.react.js';
import {viewWithDataGetPrimaryData} from '../../box-utils/PrimaryData';
import Error from '../system/Error.react.js';
import {sendError} from '../../../app/errorDisplayer';
import BoxDecorator from '../../box-utils/BoxDecorator.react';
import config from '../../../../common/config';

class GoogleDrive extends ParentBox {

    static handlerName = "google-drive";

    static propTypes = {
        isPreview: PropTypes.bool,
        viewWithData: PropTypes.object.isRequired,
    };

    getIcon() {
        return "google-drive";
    }

	getServiceName() {
		return "Google Drive";
	}

    render() {
        try {

            let data = viewWithDataGetPrimaryData(this.props.viewWithData);
            let tokens;

            if (data && data[0]) {
                data = data[0];

                tokens = [
                    data['com.dativery.model.entities.companies@name'],
                ];
            } else if (this.props.isPreview) {
                tokens = ['Prague', 'Czech Republic'];
            } else {
                throw new Error("Missing data for google-drive", data);
            }

            let map = tokens.filter((row) => row).join(', ');

            return (
                <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                    <iframe className="dativeryValue" src={"https://www.google.com/maps/embed/v1/place?q=" + encodeURIComponent(map) + "&zoom=17&key=" + config.GOOGLE_KEY} width="100%" >
                    </iframe>
                </BoxDecorator>
            );
        } catch (e) {
            sendError(e);
            return (<Error error={e} />);
        }
    }
}

export default relayWrap(GoogleDrive);
